import { Alert } from "@material-ui/lab";

import { incrementDataRevision } from "app/store/tools/revisionSlice";

const relayScheduleStatusForm = {
	urlGET: "api/profile/carriers/:carrierId/relay-schedules/:id",
	urlDELETE: "api/profile/carriers/:carrierId/relay-schedules/:id/status/:status",
	idKey: "_id",
	triggerEvent: ["relayScheduleRevision", "dataRevision"],
	listenEvent: "relayScheduleRevision",
	header: {
		delete: { label: "Change Relay Schedule Status" },
	},
	content: {
		delete: {
			items: [
				{
					type: "message",
					builder: (item) => (
						<div>
							{item?.assigned_trucks?.length > 0 && item.status === "ACTIVE" && (
								<Alert className="flex flex-row w-full mb-16" severity="info">
									This relay schedule has assigned trucks. If the schedule is deactivated, trucks may be affected.
								</Alert>
							)}
							<span className="ml-5">
								Would you like to {item.status === "ACTIVE" ? "deactivate" : "activate"} relay schedule '
								{item.schedule_name}'?
							</span>
						</div>
					),
				},
				{
					type: "group",
					content: {
						items: [
							{ type: "action", action: "CANCEL" },
							{ type: "action", action: "DELETE", label: "Continue" },
						],
					},
				},
			],
			onFinished: (_, dispatch) => {
				dispatch(incrementDataRevision({ event: "profileRevision" }));
				if (window?.ReactNativeWebView) {
					window?.ReactNativeWebView?.postMessage(JSON.stringify({ type: "REFRESH_RELAY_SCHEDULE_LIST" }));
				}
			},
		},
	},
};

export default relayScheduleStatusForm;
